import { BatchRegionConfig } from './../models/apis/batchAPI';
import { RegionKeys } from '../models/regionDict';

/**
 * *DEPRECATED* This function is no longer useful.
 *
 * Transposes a array like a Matrix.
 *
 * At the beginning, we were using this function to
 * reorder subchannels. But as css3 column layout
 * would not render in order when elements have very
 * different heights, we are going to use a new order
 * algorithm to reorder feed list.
 *
 * But we are keeping this function because there are
 * still some cases which need this function exsit, and
 * new requirements may also need this function.
 *
 * @example
 *
 *   ┌ 0   2   4 ┐
 *   └ 1   3   5 ┘
 *         ↓
 *   ┌ 0   1   2 ┐
 *   └ 3   4   5 ┘
 *
 * transposeMatrix([0, 1, 2, 3, 4, 5], 3) => [0, 3, 1, 4, 2, 5]
 *
 * @param  {any[]} arr - target array that would be transposeed
 * @param  {number} splitCount - rows that would be transfromed into
 * @returns any
 */
export const transposeMatrix = (arr: any[], splitCount: number): any[] => {
    if (splitCount <= 0) {
        throw new Error(`splitCount must be greater than 0, but got ${splitCount}`);
    }
    const tempArr: any[][] = [];
    for (let i = 0; i < splitCount; i++) {
        tempArr.push([]);
    }
    arr.forEach((item, index) => {
        tempArr[index % splitCount].push(item);
    });
    const result = tempArr.reduce((a, b) => a.concat(b));
    return result;
};

/**
 * Make an array even. If the array has odd elements,
 * push the middle element to the tail.
 *
 * @param  {any[]} target
 * @returns any
 */
export const toEven = (target: any[]): any[] => {
    if (!(target.length % 2)) {
        return target;
    }
    const index = Math.floor(target.length / 2);
    const result: any[] = target.concat([target[index]]);
    return result;
};
/**
 * Short the large number.
 *
 * 9999 => '9999'
 * 99999999 => '9999万'
 * 999999999999 => '9999亿'
 *
 * @param  {number} count
 * @returns string
 */
export const shortLargeInt = (count: number): string => {
    let res = '';
    if (count < 10000) {
        res = count.toString();
    } else if (count < 1e8) {
        res = `${Math.floor(count / 1e4).toString()}万`;
    } else if (count < 1e12) {
        res = `${Math.floor(count / 1e8).toString()}亿`;
    }
    return res;
};

/**
 * Delay function.
 *
 * @example
 *
 * async () => {
 *     await sleep(3000);
 *     // do other things
 * }
 *
 * @param  {number=1000} duration - How long you want to sleep (ms)
 */
export const sleep = (duration: number = 1000) => new Promise(resolve => setTimeout(() => resolve(), duration));

/**
 * Gennerate a simple batch region instance config.
 *
 * @param  {RegionKeys} regionId
 * @param  {number=10} size
 * @param  {1|2|3=3} integrateType
 * @param  {string='no.spm.at.current.moment'} spm
 * @returns BatchRegionConfig
 */
export const genBatchConfig = (regionId: RegionKeys, size: number = 10, integrateType:1|2|3 = 3, forceUseNewData: boolean = false, spm:string = 'no.spm.at.current.moment'): BatchRegionConfig => {
    const config: BatchRegionConfig = {
        regionId,
        size,
        integrateType,
        spm,
        forceUseNewData,
        adapter: 'pc',
    };
    return config;
};

export const genCisBatchConfig = (spmCode: string, size:number = 10, page = 1) =>{
    let spm = '';
    if(!/^smpc.home-classic./.test(spmCode)) {
        spm = `smpc.home-classic.${spmCode}`;
    }
    const config: any = {
        spm,
        size,
        page,
    };
    return config;
};



// WEBPACK FOOTER //
// ./src/utils/index.ts